import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { User } from 'src/app/models/user';
import { VproService } from 'src/app/service/vpro/vpro.service';
import Swal from 'sweetalert2';
import { Utils } from 'src/app/common/utils';
import { Buffer } from 'buffer';
@Component({
  selector: 'app-reset-pass-new',
  templateUrl: './reset-pass-new.component.html',
  styleUrls: ['./reset-pass-new.component.css']
})
export class ResetPassNewComponent implements OnInit {
  isMutePass: boolean = false;
  isMuteCfmPass: boolean = false;
  user = new User();
  passwordRegex = Utils.passwordRegex;
  constructor(private service: VproService, private route: ActivatedRoute, private router: Router, private spinner: NgxSpinnerService,) { }

  ngOnInit() {
    let email_id = this.route.snapshot.queryParams['email_id'];
    // this.user.email_id = email_id.replace(" ", "+"); // For email patterns having + sign
    if (email_id) {
      console.log("email_id", email_id)
      let buff = new Buffer(email_id, 'base64');
      let text = buff.toString('ascii');
      console.log("text", text)
      let emails = text.replace(" ", "+"); // For email patterns having + sign

      // this.user.email_id = email_id.toLowerCase();
      this.user.email_id = emails.toLowerCase();
    }
    if (this.route.snapshot.queryParams['account_type'])
      this.user.account_type = this.route.snapshot.queryParams['account_type'];
  }
  resetUserPass(): void {
    this.spinner.show();
    console.log("this.user", this.user)
    this.service.setUserPass(this.user)
      .subscribe(res => {
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: 'top',
          type: 'success',
          title: 'New Password has been reset successfully. You can login with the new password.',
          showConfirmButton: false,
          timer: 3000
        });
        this.router.navigate(['./login'])
      }, error => {
        this.spinner.hide();
        console.log(error);
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "error",
          title:
            error && error.error && error.error.error ? error.error.error : "Something Went wrong",
          showConfirmButton: false,
          timer: 2100
        });
      });
  }
}
